import { ExpenseSubMode } from "@common/types/domains/accounting/schedule";

export function isPrepaidExpenseSubMode(
    expenseSubMode: ExpenseSubMode | null,
): boolean {
    return expenseSubMode === ExpenseSubMode.prepaid;
}
